//Stateler çekilip return edilecek
export const getAccountLoading = (state) => {
    return state.loading
}

export const getAccountDetail = (state) => {
    return state.accountDetail
}

export const getNewAccountNo = (state) => {
    return state.newAccountNo
}

export const accountId = (state) => {
    return state.accountId
}

export const getAccountStatus = (state) => {
    return state.status
}

export const getAccountZones = (state) => {
    return state.zones
}

export const getAccountUsers = (state) => {
    return state.users
}

export const getAlertDefs = (state) => {
    return state.alertDefs
}

export const getAccountAlertDefs = (state) => {
    return state.accountAlertDefs
}

export const getAccountNotes = (state) => {
    return state.notes
}

export const getAccountNotifications = (state) => {
    return state.notifications
}

export const getAccountHours = (state) => {
    return state.hours
}

export const getTracings = (state) => {
    return state.tracings
}

export const getAccounts = (state) => {
    return state.accounts
}
export const getAccountPageInfo = (state) => {
    return state.accountPageInfo
}

export const getAccountCommunications = (state) => {
    return state.communications
}

export const getAccountAddress = (state) => {
    return state.accountAddress
}

export const getAccountVacations = (state) => {
    return state.accountVacations
}

export const getAccountCameras = (state) => {
    return state.accountCameras
}

export const getAccountDevices = (state) => {
    return state.accountDevices
}



// WEBPACK FOOTER //
// ./src/store/modules/Alarmsis/Account/Getters.js